/**
 * Angular imports.
 */
import { Component, EventEmitter, Input, Output, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
/**
 * Constant imports.
 */
import {
  BREADCRUMB_PATHS,
  COMMUNITY_DETAIL_ACTION_TAB,
  PRODUCT_TYPE_CONSTANT,
  NUMBERS,
  COMMUNITY_USER_TYPE,
  SPECIAL_CHARACTER,
  COMMUNITY_POSTED_CONTENT_TYPE_ACTION,
  STATUS_CODE,
  COMMUNITY_STATUS,
  COMMUNITY_PRIVACY,
  COMMUNITY_JOIN_TYPE,
  COMMUNITY_MEMBERS_ACTION,
  COMMUNITY_JOIN_ACTION,
  COMMUNITY_DETAIL_PAGE_TAB_FILTER_TEXT,
  ERROR_CODES,
  SCREEN_NAME,
  MEMBERS_LIST_TYPE,
  IS_SUGGESTION,
  MEMBERS_LIMIT,
  PRODUCT_TYPE_CONSTANT_NAME,
  ACTION_ON,
  ACTION_TYPE,
  CTA_TYPE,
  COMMUNITY_POST_TOPIC
} from '../../constants/app.constants';
import { EVENT_NAME } from '../../analytics-event/analytics.constant';
import { CLICK, DETAIL_ENTRY, DETAIL_EXIT } from 'analytics2.0/dist/core/constants/analytic.interface';
/**
 * Modal imports.
 */
import { Community, ConfirmationModalData } from '../../onboarding/interface/global.model';
import { CommunityDetailResponse, CommunityMembersResponse } from '../../onboarding/interface/apiResponse.model';
import { GenericResponse } from '../../onboarding/interface/apiResponse.model';
/**
 * Service imports
 */
import { NewLanguageService } from './../../dataservices/new-language/new-language.service';
import { DataStorageService } from './../../dataservices/data-storage.service';
import { GetService } from './../../dataservices/get.service';
import { FunCollectionService } from '../../common/common-functions/fun-collection.service';
import { FileUploadService } from '../../dataservices/file-upload.service';
import { PostApiService } from './../../dataservices/post-api.service';
/**
* Rxjs imports.
*/
import { Subject, Subscription } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { CreateCommunityService } from '././../create-community/create-community.service';
import { PostingService } from './../../web/posting/posting.service';
import { SurveyService } from '../../dataservices/survey/survey.service';

/**
 * sdk imports
 */
import { Analytics } from 'analytics2.0';
/**
 * Show the individual community detail.
 */

@Component({
  selector: 'app-community-detail',
  templateUrl: './community-detail.component.html',
  styleUrls: ['./community-detail.component.scss']
})
export class CommunityDetailComponent implements OnInit, OnDestroy {
  /**
  * Show the individual community list.
  * Show the translations key.
  * Check the last element of error.
  */
  @Input() community: Community;
  @Input() isLast: boolean;

  /**
   * Emit the edit, delete, unFollow, report , detail event outside.
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  @Output() emitCommunityEdit: EventEmitter<any> = new EventEmitter();
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  @Output() emitCommunityDelete: EventEmitter<any> = new EventEmitter();
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  @Output() emitCommunityUnFollow: EventEmitter<any> = new EventEmitter();
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  @Output() emitCommunityReport: EventEmitter<any> = new EventEmitter();
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  @Output() emitCommunityDetail: EventEmitter<any> = new EventEmitter();
  /**
   * Community Detail Bread Crumb
  */
  public communityDetailBreadcrumb = [];
  /**
   * Community Detail Action Tab
  */
  public communityDetailActionTab = COMMUNITY_DETAIL_ACTION_TAB;
  /**
   * Community Detail Action Default Tab
  */
  public tabSuccess = COMMUNITY_DETAIL_ACTION_TAB.POSTS;
  /**
   * Community Id
  */
  public communityId: string;
  /**
   * Community Detail
  */
  public communityDetail: Community;
  /**
   * Constant for privacy
   */
  public privacy = COMMUNITY_PRIVACY;
  /**
   * Translations Data
   */
  public translations = {
    key1: this.mls.languageText.community.key9,
    key2: this.mls.languageText.community.key5,
    key3: this.mls.languageText.community.key6,
    key4: this.mls.languageText.community.key7,
    key5: this.mls.languageText.community.key8,
    key6: this.mls.languageText.community.key11,
    key7: this.mls.languageText.community.key37,
    key8: this.mls.languageText.community.key45,
    key9: this.mls.languageText.community.key19,
    key10: this.mls.languageText.community.key42,
    key11: this.mls.languageText.community.key46,
    key12: this.mls.languageText.community.key47,
    key13: this.mls.languageText.community.key48,
    key14: this.mls.languageText.community.key49,
    key15: this.mls.languageText.community.key72,
    key16: this.mls.languageText.community.key74,
    key17: this.mls.languageText.community.key75,
    key18: this.mls.languageText.community.key96,
    key19: this.mls.languageText.community.key115,
  };
  /**
   * Posted By Filter Data
   */
  public postedByFilterData;
  /**
   * Members By Filter Data
   */
  public membersFilterData;
  /**
   * To unsubscribe data.
   */
  private subscriptions: Subscription = new Subscription();
  /**
   * Member Type
   */
  public memberType = COMMUNITY_USER_TYPE;
  /**
   * Special Character Constant
   */
  public specialCharacter = SPECIAL_CHARACTER;
  /**
   * Post Data by Filter
   */
  public postDataByFilter = [];
  /**
   * Posted By Filter offset Data
   */
  public postedByFilterOffset = NUMBERS.ONE;
  /**
   * @notifier$ defines a notifier subject stream to end data streaming
   */
  private notifier$ = new Subject();

  /**
   * Is user is crator.
   */
  public isCreator = NUMBERS.ONE;
  /**
   * Is user is past member.
   */
  public isPast = NUMBERS.ONE;
  /**
   * Exit modal.
   */
  public showExitModal = false;
  /**
   *  Error Message
   */
  public errorMessage = '';
  /**
   * Check for Loader
   */
  public finished = true;
  /**
   * Inactive modal flag.
   */
  public showInactivateModal = false;
  /**
   * Inactive confirm modal flag.
   */
  public showInactivateConfirmModal = false;
  /**
   * Inactive/active access level.
   */
  public activateAccess: string;
  /**
   * Is community active.
   */
  public isCommunityActive = NUMBERS.ONE;
  /**
   * Show deactivate option key.
   */
  public showDeactivateOptionNudge = false;
  /**
   * Check for Post Data Loader
   */
  public postDataLoader = false;

  /**
   * Loader for ongoing request
   */
  public loader: boolean;
  /**
   * for getting community id
   */
  public communityDetailId: number;

  /**
   * constant for NUMBERS
   */
  public numbers = NUMBERS;
  public withdrawRequest = false;
  public confirmationModal = false;
  public confirmationText: ConfirmationModalData =
    {
      headingText: '',
      cancelButtonText: '',
      allowButtonText: '',
      bodyText: ''
    };
  /**
   * Community Joining Requests Data
   */
  public joiningRequestsData = [];
  /**
   * Join Request Off Set
   */
  public joinRequestOffSet = NUMBERS.ONE;
  /**
   * Join Request API Loader
   */
  public joinRequestAPILoader = false;
  /**
   *
   */
  public communityDetailPageTabFilterText = COMMUNITY_DETAIL_PAGE_TAB_FILTER_TEXT;
  /**
   * flag to reload feed data
   */
  private isReloadFeed = false;
  /**
   * for capturing value of is_past_community
   */
  public pastMember: number;
  /**
   *  For storing value before response
   */
  public postDataLoaded = NUMBERS.ZERO;
  /**
   * Analytics session time.
   */
  private sessiontime = { 'start_time': '', 'end_time': '' };
  /**
   * Calling from screen name
   */
  public callingFrom = SCREEN_NAME.COMMUNITY_DETAILS;

  /**
   * To check for post
   */
  public isPosted = 0;
  /**
   * List for members
   * Check members selection open/close.
   * Check members view all enable or not
   * define search type
   * defining member keyword
   * List for preselected members
   * check for mobile back button flag
   * show existing user flag
   * check for member concat
   * member count for total members
   * define community data
   * list for members selection removal
   * placeholder for filter
   * selection label
   * pop up label
   * max limit for members
   * defining offset
   *
   */
  public selectedMembers = [];
  public isMembersSelectionOpen = false;
  public membersIsViewAllEnable = false;
  public membersSearchType = MEMBERS_LIST_TYPE.CONNECTION;
  public membersIsSuggestion = IS_SUGGESTION.YES;
  public membersKeyword = '';
  public preSelectedMembersList = [];
  public originalSelectedMembersList = [];
  public showMobileBackButtonFlag = false;
  public showExistingUsersFlag = false;
  public isMemberConcat = true;
  public memberCount: number;
  public communityData: object = {};
  public membersSelectedRemoved = [];
  public membersFilterPlaceholder = this.mls.languageText.community.key26;
  public membersSelectionLabel = this.mls.languageText.community.key12;
  public membersPopupLabel = `${this.mls.languageText.community.key16} ${this.mls.languageText.community.key19}`;
  public membersNoDataFoundLabel = this.mls.languageText.community.key17;
  public membersSelectedTitle = this.mls.languageText.community.key18;
  public membersSelectedLimit = MEMBERS_LIMIT;
  public membersTitle = this.mls.languageText.community.key19;
  public membersMaxLimitErrorLabel = this.mls.languageText.community.key14;
  public offset: number;
  // TODO : Add Typing
  public memberToBeAdded = [];

  public startTime = 0;

  /**
   * Check the status of post button.
   */
  public isPostButtonDisable = false;

  /**
   * Topic list
   */
  public topicList = [];
  /**
   * Community posting and topic keys.
   */
  public contentPost : string;
  public contentTopic: string;
  /**
   * Constant.
   */
  public COMMUNITY_POST_CONSTANT = COMMUNITY_POST_TOPIC;


  /**
   * Needed instance.
   */
  constructor(
    public mls: NewLanguageService,
    public dss: DataStorageService,
    public getApiService: GetService,
    public fcs: FunCollectionService,
    public route: ActivatedRoute,
    public fileus: FileUploadService,
    private postService: PostApiService,
    public router: Router,
    public createCommunityService: CreateCommunityService,
    private postingService: PostingService,
    private surveyService: SurveyService,
    private analyticSdk: Analytics
  ) {
    this.communityId = this.route.snapshot.params['communityId'];
  }

  ngOnInit(): void {
    this.postingService.selectedCommunity = this.communityId;
    this.getCommunityDetail();
    this.fcs.currentScreename = SCREEN_NAME.COMMUNITY_DETAIL;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    this.fileus.new_feed_post_added.subscribe((data: any) => {
      if (data) {
        this.postDataByFilter = [];
        this.getPostedByFilterData();
        this.getPostsData();
      }
    });
    this.dss.edited_feed_obj.subscribe((data) => {
      if (data) {
        this.postDataByFilter = [];
        this.getPostedByFilterData();
        this.getPostsData();
      }
    });
    this.getNudgedata();
    this.requestWithdrawStatus();
    this.confirmationText.bodyText = this.mls.languageText.community.key91;
    this.confirmationText.headingText = this.mls.languageText.community.key92;
    this.confirmationText.allowButtonText = this.mls.languageText.community.key93;
    this.confirmationText.cancelButtonText = this.mls.languageText.community.key94;

    const d = new Date();
    this.sessiontime.start_time = d.getTime().toString();

    this.postDisableCheck();
  }

  /**
   * get Nudge data
   */
  getNudgedata(): void {
    this.getApiService.getNudgeData(NUMBERS.ONE, 'action')
      .subscribe(resData => {
        if (resData.status === NUMBERS.ONE) {
          this.activateAccess = resData.data['community'].activate_deactivate_access;
        }
      });
  }
  /**
   * On Page Scroll Event
  */
  onScroll(): void {
    // No Code
  }

  /**
   * Emit the edit event outside.
  */
  edit(): void {
    this.dss.callingFromCommunityForEdit = NUMBERS.ONE;

    const d = new Date();
    this.sessiontime.start_time = d.getTime().toString();
    /**
     * Set analytics data for analytics event.
     */
    this.analyticSdk.analyticService.CLICK(PRODUCT_TYPE_CONSTANT_NAME.COMMUNITY,this.communityDetail?.da_id  ?? 0,SCREEN_NAME.COMMUNITY_DETAILS, CTA_TYPE.MORE_OPTION, ACTION_TYPE.CLICK,ACTION_ON.EDIT_COMMUNITY, null);
    this.fcs.navigateToCommunityEditPage(this.communityDetail.id);
  }

  /**
   * Emit the delete event outside.
   */
  delete(): void {
    this.emitCommunityDelete.emit();
  }

  /**
   * Emit the unFollow event outside.
   */
  unFollow(): void {
    this.emitCommunityUnFollow.emit();
  }

  /**
   * Emit the report event outside.
   */
  report(): void {
    this.emitCommunityReport.emit();
  }
  /**
   * Emit The Community Detail Event Outside
   */
  goToCommunityDetail(community): void {
    this.emitCommunityDetail.emit(community);
  }
  /**
    * Mobile Filter
  */
  mobileFilter(): void {
    // No Code
  }
  /**
   * Show General Post Modal
  */
  showPostModal(): void {
    this.analyticSdk.analyticService.CLICK(PRODUCT_TYPE_CONSTANT_NAME.COMMUNITY,this.communityDetail?.da_id  ?? 0,SCREEN_NAME.COMMUNITY_DETAILS, CTA_TYPE.BUTTON, ACTION_TYPE.CLICK,ACTION_ON.CREATE_POST, null);
    this.dss.posting_data.screen3.selected_community.push(this.communityId);
    this.dss.calling_from_community = 1;
    this.dss.calling_from_community_object = this.communityDetail;
    // community post
    if( this.contentTopic === COMMUNITY_POST_TOPIC.CONTENT_TOPIC_LINK){
      this.dss.nextButtonEnabled = true;
      this.dss.contentTopic = COMMUNITY_POST_TOPIC.CONTENT_TOPIC_LINK;
      this.dss.topic_community_flag = 1;
    }
    this.dss.show_feed_post_modal.next(1);
  }
  /**
   * Perform Selected Tab Either Posts or Members
  */
  selectedTab(tabName, toFireAnalytics?: false): void {
    if (tabName && toFireAnalytics) {
      const actionOn = tabName.toUpperCase() + '_TAB';
      this.analyticSdk.analyticService.CLICK(PRODUCT_TYPE_CONSTANT_NAME.COMMUNITY, this.communityDetail?.da_id ?? 0, SCREEN_NAME.COMMUNITY_DETAIL, CTA_TYPE.TAB, ACTION_TYPE.CLICK, actionOn, null);
    }
    this.tabSuccess = tabName;
    // if( this.tabSuccess == 'posts'){
    //   this.getCommunityDetail();
    // }
  }

  /**
   * Get Community Detail
   */
  getCommunityDetail(): void {
    this.finished = false;
    this.errorMessage = '';
    this.subscriptions.add(this.getApiService.getCommunityDetail(this.communityId).subscribe((res: CommunityDetailResponse) => {
      this.finished = true;
      if (res.status === NUMBERS.ONE) {
        if (res.code === STATUS_CODE.TWO_THOUSAND) {
          this.communityDetail = res.data.detail;
          this.pastMember = this.communityDetail.flags.is_past_community;
          if (this.communityDetail?.flags?.show_join_button === NUMBERS.ZERO || this.communityDetail?.flags?.is_past_community === NUMBERS.ONE) {
            this.loadPageContent();
            if (this.route.snapshot.params['tabName'] === COMMUNITY_DETAIL_ACTION_TAB.POSTS || this.route.snapshot.params['tabName'] === COMMUNITY_DETAIL_ACTION_TAB.MEMBERS) {
              this.tabSuccess = this.route.snapshot.params['tabName'] ? this.route.snapshot.params['tabName'] : COMMUNITY_DETAIL_ACTION_TAB.POSTS;
            }
          }
          if (this.communityDetail?.member_type === COMMUNITY_USER_TYPE.ADMIN) {
            if (!this.communityDetail.flags.is_active) {
              this.selectedTab(COMMUNITY_DETAIL_ACTION_TAB.POSTS);
            } else {
              this.getCommunityMembersJoinRequest();
            }
          }
          if (this.startTime == 0) {
            const detailentry: DETAIL_ENTRY = {
              entity_type: PRODUCT_TYPE_CONSTANT_NAME.COMMUNITY,
              entity_code: this.communityDetail?.da_id ?? '0',
              source: this.fcs.currentScreename ?? localStorage.getItem('triggerSource'),
              current_screen_name: SCREEN_NAME.COMMUNITY_DETAIL,
              start_time: this.startTime = new Date().getTime()
            }
            this.analyticSdk.analyticService.DETAIL_ENTRY(detailentry);
          }
          // Policy support for topic
          if(this.communityDetail?.actions?.length > 0 ){
            this.contentPost = this.communityDetail?.actions?.find((element)=>element === COMMUNITY_POST_TOPIC.CONTENT_POST);
            this.contentTopic = this.communityDetail?.actions?.find((element)=>element === COMMUNITY_POST_TOPIC.CONTENT_TOPIC_LINK);
            if(this.contentTopic == COMMUNITY_POST_TOPIC.CONTENT_TOPIC_LINK){
              this.getTopicList();
            }
          }
          // Legacy support for topic
          else if(this.communityDetail?.flags){
            if(this.communityDetail?.flags?.can_post === 1){
              this.contentPost =  COMMUNITY_POST_TOPIC.CONTENT_POST
            }
            if(this.communityDetail?.flags?.is_topic_community === 1){
              this.contentTopic = COMMUNITY_POST_TOPIC.CONTENT_TOPIC_LINK;
            }
            if(this.contentTopic == COMMUNITY_POST_TOPIC.CONTENT_TOPIC_LINK){
              this.getTopicList();
            }
          }

        } else {
          this.errorMessage = res.msg;
        }
      } else {
        if (res?.error?.code == STATUS_CODE.ONE_THOUSAND_FIVE) {
          this.errorMessage = res.error.msg;
        }
        this.fcs.errorHandeler(res);
      }
      /**
       * Community detail breadcrumb on the basis of past and current community.
       */
      if (this.communityDetail?.flags?.is_past_community === this.isPast) {
        this.communityDetailBreadcrumb = [
          { name: this.mls.languageText.community.key25, path: BREADCRUMB_PATHS.HOME },
          { name: this.mls.languageText.community.key1, path: BREADCRUMB_PATHS.COMMUNITY_LIST },
          { name: this.mls.languageText.community.key63, path: BREADCRUMB_PATHS.COMMUNITY_PAST_LIST },
          { name: this.mls.languageText.community.key64, path: '' },
        ];
      } else {
        this.communityDetailBreadcrumb = [
          { name: this.mls.languageText.community.key25, path: BREADCRUMB_PATHS.HOME },
          { name: this.mls.languageText.community.key1, path: BREADCRUMB_PATHS.COMMUNITY_LIST },
          { name: `${this.mls.languageText.community.key1} ${this.mls.languageText.community.key32} `, path: '' },
        ];
      }
    }, (err) => this.fcs.errorHandeler(err))
    );
  }

  /**
   * Get Posted By Filter Data
   */
  getPostedByFilterData(): void {
    const product_type = PRODUCT_TYPE_CONSTANT.COMMUNITY.toString();
    const section_name = COMMUNITY_DETAIL_ACTION_TAB.POSTS.toUpperCase();
    this.subscriptions.add(this.getApiService.getPostedByFilterData(product_type, section_name).subscribe((res) => {
      if (res.status === NUMBERS.ONE) {
        this.postedByFilterData = res?.data;

        /**
         * Remove content type filter if that is a topic filter.
         */
        if(this.contentTopic == COMMUNITY_POST_TOPIC.CONTENT_TOPIC_LINK){
          const contentIndex = this.postedByFilterData.filter.findIndex(item =>item.key === 'community_content_type');
          this.postedByFilterData.filter.splice(contentIndex);
        }

        for (let i = 0; i < this.postedByFilterData.filter.length; i++) {
          this.postedByFilterData.filter[i]['list'].unshift({ value: '', name: this.translations.key10, logo: '' });
        }
      } else {
        this.fcs.errorHandeler(res);
      }
    }, (err) => this.fcs.errorHandeler(err))
    );
  }
  /**
   * Function is used to get specialty.
   */
  getFeedTagDetails(speciality): void {
    this.dss.specialty_filter = speciality;
    this.analyticSdk.analyticService.CLICK(PRODUCT_TYPE_CONSTANT_NAME.COMMUNITY, this.communityDetail?.da_id ?? 0, SCREEN_NAME.EC_DETAIL, CTA_TYPE.TEXT, ACTION_TYPE.CLICK, ACTION_ON.SPECIALITY_HASTAG, null);
    this.fcs.navigateToHome();
  }
  /**
   * Get Members Filter Data
   */
  getMembersFilterData(): void {
    const product_type = PRODUCT_TYPE_CONSTANT.COMMUNITY.toString();
    const section_name = COMMUNITY_DETAIL_ACTION_TAB.MEMBERS.toUpperCase();
    this.subscriptions.add(this.getApiService.getMembersFilterData(product_type, section_name).subscribe((res) => {
      if (res.status === NUMBERS.ONE) {
        this.membersFilterData = res.data;
        for (let i = 0; i < this.membersFilterData.filter.length; i++) {
          this.membersFilterData.filter[i]['list'].unshift({ value: '', name: this.translations.key10, logo: '' });
        }
      } else {
        this.fcs.errorHandeler(res);
      }
    }, (err) => this.fcs.errorHandeler(err))
    );
  }
  /**
   * getPostsData
   */
  getPostsData(filterObj?): void {
    this.postDataLoader = false;
    this.selectedTab(COMMUNITY_DETAIL_ACTION_TAB.POSTS);
    const posted_by = filterObj ? (filterObj[COMMUNITY_POSTED_CONTENT_TYPE_ACTION.POSTED_BY] ? filterObj[COMMUNITY_POSTED_CONTENT_TYPE_ACTION.POSTED_BY] : '') : '';
    const content_type = filterObj ? (filterObj[COMMUNITY_POSTED_CONTENT_TYPE_ACTION.CONTENT_TYPE] ? filterObj[COMMUNITY_POSTED_CONTENT_TYPE_ACTION.CONTENT_TYPE] : '') : '';
    const topic = filterObj ? (filterObj[COMMUNITY_POSTED_CONTENT_TYPE_ACTION.TOPIC] ? filterObj[COMMUNITY_POSTED_CONTENT_TYPE_ACTION.TOPIC] : '') : '';
    this.postedByFilterOffset = filterObj ? (filterObj['offset'] ? filterObj['offset'] : '1') : '1';
    this.subscriptions.add(this.getApiService.getPostDataByFilter(posted_by, content_type, this.communityId, this.postedByFilterOffset.toString(), topic).subscribe((res) => {
      if (res.status === NUMBERS.ONE) {
        if (this.isReloadFeed) {
          this.postDataByFilter = [];
        }
        this.postDataByFilter = this.postDataByFilter.concat(res.data.mix_list);
        this.postDataLoaded = NUMBERS.ONE;
        this.postedByFilterOffset = res.data.offset;
        this.postDataLoader = true;
        this.isPosted = this.postDataByFilter.length;
      } else {
        this.fcs.errorHandeler(res);
      }
    }, (err) => this.fcs.errorHandeler(err))
    );
  }
  /**
   * Function called from community post filter component
   */
  getPostsByFilter(filterObj): void {
    if (filterObj['scroll']) {
      filterObj['offset'] = filterObj['offset'] ? filterObj['offset'] : NUMBERS.ONE;
    }
   else {
    this.postDataByFilter = [];
    filterObj['offset'] = NUMBERS.ONE;
    this.postedByFilterOffset = NUMBERS.ONE;
  }
  this.getPostsData(filterObj);
  
  }
  /**
   * When user click on exit dropdown.
   */
  exitCommunity(): void {
    this.analyticSdk.analyticService.CLICK(PRODUCT_TYPE_CONSTANT_NAME.COMMUNITY, this.communityDetail?.da_id ?? 0, SCREEN_NAME.COMMUNITY_DETAIL, CTA_TYPE.BUTTON, ACTION_TYPE.CLICK, ACTION_ON.EXIT_COMMUNITY, null);
    this.showExitModal = true;
  }
  /**
   * When user click on close or ESC.
   */
  onHidden(): void {
    this.showExitModal = false;
    this.showInactivateModal = false;
    this.showInactivateConfirmModal = false;
  }
  /**
   * Exit Community Member
   */
  exitCommunityConfirm(): void {
    this.analyticSdk.analyticService.CLICK(PRODUCT_TYPE_CONSTANT_NAME.COMMUNITY, this.communityDetail?.da_id ?? 0, SCREEN_NAME.COMMUNITY_DETAIL, CTA_TYPE.BUTTON, ACTION_TYPE.CLICK, ACTION_ON.EXIT_COMMUNITY_CONFIRM, null);
    this.subscriptions.add(this.postService.exitCommunityMember(this.communityId)
      .subscribe((res: GenericResponse) => {
        if (res.status === NUMBERS.ONE) {
          this.showExitModal = false;
          this.postedByFilterOffset = NUMBERS.ONE;
          this.postDataByFilter = [];
          this.getCommunityDetail();
          this.getPostedByFilterData();
          this.tabSuccess = COMMUNITY_DETAIL_ACTION_TAB.POSTS;
        } else {
          this.fcs.errorHandeler(res);
        }
      }, err => this.fcs.errorHandeler(err)));
  }

  /**
   * On Destroy
   */
  ngOnDestroy(): void {
    const detailExit: DETAIL_EXIT = {
      entity_type: PRODUCT_TYPE_CONSTANT_NAME.COMMUNITY,
      entity_code: this.communityDetail?.da_id ?? 0,
      current_screen_name: SCREEN_NAME.COMMUNITY_DETAIL,
      start_time: this.startTime,
      end_time: new Date().getTime()
    }
    this.analyticSdk.analyticService.DETAIL_EXIT(detailExit);
    if (this.subscriptions) {
      this.subscriptions.unsubscribe();
    }
    this.dss.calling_from_community = NUMBERS.ZERO;
    this.dss.calling_from_community_object = {};
    this.notifier$.next();
    this.notifier$.complete();

    const d = new Date();
    this.sessiontime.end_time = d.getTime().toString();
  }

  /**
   * property to check join public community button is enabled
   */
  get isJoinActionEnabled(): boolean {
    return (this.communityDetail
      && this.communityDetail.flags.show_join_button === NUMBERS.ONE
      && this.communityDetail.member_type === ''
      && this.communityDetail.privacy === COMMUNITY_PRIVACY.PUBLIC
      && this.communityDetail.join_type === COMMUNITY_JOIN_TYPE.AUTOMATIC);
  }

  /**
   * property to check request to join public community button is enabled
   */
  get isRequestJoinActionEnabled(): boolean {
    return (this.communityDetail
      && this.communityDetail.flags.show_join_button === NUMBERS.ONE
      && this.communityDetail.member_type === ''
      && this.communityDetail.privacy === COMMUNITY_PRIVACY.PUBLIC
      && this.communityDetail.join_type === COMMUNITY_JOIN_TYPE.APPROVAL);
  }

  /**
   * Event handler for join public community
   */
  joinCommunityHandler(): void {
    this.loader = true;
    this.fcs.joinPublicCommunity(this.communityDetail.id).pipe(
      takeUntil(this.notifier$)
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
    ).subscribe((response: any) => {
      this.loader = false;
      if (response.status === NUMBERS.ONE) {
        this.postDataByFilter = [];
        this.getCommunityDetail();
      } else {
        this.fcs.errorHandeler(response);
      }
    },
      (error) => {
        this.loader = false;
        this.fcs.errorHandeler(error);
      });
  }
  /**
   * Event handler for request to admin to join public community
   */
  requestToJoinHandler(action: string): void {
    this.analyticSdk.analyticService.CLICK(PRODUCT_TYPE_CONSTANT_NAME.COMMUNITY, this.communityDetail?.da_id ?? 0, SCREEN_NAME.COMMUNITY_DETAILS, CTA_TYPE.BUTTON, ACTION_TYPE.CLICK, ACTION_ON.COMMUNITY_JOIN_REQUEST, null);
    this.loader = true;
    this.fcs.joinPublicCommunity(this.communityDetail.id, action).pipe(
      takeUntil(this.notifier$)
    ).subscribe(response => {
      this.loader = false;
      if (response.status === this.numbers.ONE && response.code === this.numbers.TWO_THOUSAND) {
        this.fcs.showSuccess(this.mls.languageText.community.key89, this.mls.languageText.toster.key2);
        this.withdrawRequest = true;
      }
      if (response.error && response.error.code === ERROR_CODES.ALREADY_EXIST) {
        this.fcs.showSuccess(response.error.msg, this.mls.languageText.toster.key2);
        this.withdrawRequest = false;
        this.getCommunityDetail();
      }
    });
  }

  /**
   * Join community on conditional base.
   */
  joinCommunity(): void {
    const start_time = new Date().getTime().toString();

    if (this.communityDetail?.flags?.is_active === NUMBERS.ZERO) {
      return;
    }
    if (this.withdrawRequest || this.communityDetail?.request?.response === this.numbers.TWO) {
      this.analyticSdk.analyticService.CLICK(PRODUCT_TYPE_CONSTANT_NAME.COMMUNITY, this.communityDetail?.da_id ?? 0, SCREEN_NAME.COMMUNITY_DETAILS, CTA_TYPE.BUTTON, ACTION_TYPE.CLICK, ACTION_ON.WITHDRAW_REQUEST, null);
      this.confirmationModal = true;
    } else {
      this.communityDetail?.join_type === COMMUNITY_JOIN_TYPE.APPROVAL
        ? this.requestToJoinHandler(this.numbers.ONE.toString())
        : this.joinCommunityHandler();

      if (this.communityDetail?.join_type === COMMUNITY_JOIN_TYPE.APPROVAL) {
        this.sessiontime.start_time = new Date().getTime().toString();
        this.analyticSdk.analyticService.CLICK(PRODUCT_TYPE_CONSTANT_NAME.COMMUNITY, this.communityDetail?.da_id ?? 0, SCREEN_NAME.COMMUNITY_DETAILS, CTA_TYPE.BUTTON, ACTION_TYPE.CLICK, ACTION_ON.COMMUNITY_JOIN_REQUEST, null);

      } else if (this.communityDetail?.join_type === COMMUNITY_JOIN_TYPE.AUTOMATIC) {
        this.sessiontime.start_time = new Date().getTime().toString();
        this.analyticSdk.analyticService.CLICK(PRODUCT_TYPE_CONSTANT_NAME.COMMUNITY, this.communityDetail?.da_id, SCREEN_NAME.COMMUNITY_DETAILS, CTA_TYPE.BUTTON, ACTION_TYPE.CLICK, ACTION_ON.JOIN_COMMUNITY, null);
      }
    }
  }
  /**
   * Withdraw actions to get on card CTA click.
   */
  requestWithdrawStatus(): void {
    this.fcs.getWithdrawStatus.pipe(takeUntil(this.notifier$))
      .subscribe(community => {
        this.loader = true;
        if (community && community !== undefined) {
          this.fcs.joinPublicCommunity(
            this.communityDetail.id,
            this.numbers.ZERO.toString()).pipe(
              takeUntil(this.notifier$)
            ).subscribe(response => {
              this.loader = false;
              if (response.status === this.numbers.ONE && response.code === this.numbers.TWO_THOUSAND) {
                community['request'].response = this.numbers.ZERO;
                community['request'].type = '';
                this.fcs.showSuccess(this.mls.languageText.community.key90, this.mls.languageText.toster.key2);
                this.withdrawRequest = false;
              }
              if (response.error && response.error.code === ERROR_CODES.ALREADY_EXIST) {
                this.fcs.showSuccess(response.error.msg, this.mls.languageText.toster.key2);
                this.withdrawRequest = false;
                this.getCommunityDetail();
              }
            },
              (error) => {
                this.loader = false;
                this.fcs.errorHandeler(error);
              });
        }
      });
  }
  /**
   * Detail translation text.
   */
  translationText(isButton: boolean): string {
    return (isButton ? (this.communityDetail?.join_type === COMMUNITY_JOIN_TYPE.APPROVAL
      ? (this.withdrawRequest || this.communityDetail?.request?.response === this.numbers.TWO ? this.mls.languageText.community.key88 : this.mls.languageText.community.key103)
      : this.mls.languageText.community.key72)
      : this.withdrawRequest || this.communityDetail?.request?.response === this.numbers.TWO ? this.translations.key19 : this.translations.key16);
  }
  /**
   * Get Community Members Join Request Data
   */
  getCommunityMembersJoinRequest(event?): void {
    const filterType = COMMUNITY_MEMBERS_ACTION.PENDING.toUpperCase();
    const offSet = event && event?.offSet ? event.offSet : NUMBERS.ONE;
    this.joinRequestAPILoader = false;
    this.subscriptions.add(this.getApiService.getPendingCommunityMembers(this.communityId, offSet, filterType).subscribe((res) => {
      if (res.status === NUMBERS.ONE) {
        if (event && event.action === COMMUNITY_JOIN_ACTION.ACCEPT) {
          this.communityDetail.members.count++;
        }
        if (res.data.members.length) {
          if (offSet > NUMBERS.ONE) {
            this.joiningRequestsData = this.joiningRequestsData.concat(res.data.members);
          } else {
            this.joiningRequestsData = res.data.members;
          }
          if (this.route.snapshot.params['tabName']) {
            this.tabSuccess = this.route.snapshot.params['tabName'];
          } else {
            this.selectedTab(COMMUNITY_DETAIL_PAGE_TAB_FILTER_TEXT.JOIN_REQUESTS);
          }
        } else {
          this.joiningRequestsData = [];
          if (this.route.snapshot.params['tabName'] === COMMUNITY_DETAIL_ACTION_TAB.MEMBERS) {
            this.selectedTab(this.route.snapshot.params['tabName']);
          } else {
            this.selectedTab(COMMUNITY_DETAIL_PAGE_TAB_FILTER_TEXT.POSTS);
          }

        }

        this.joinRequestOffSet = res.data.offset;
        this.joinRequestAPILoader = true;
      } else {
        this.joinRequestAPILoader = true;
        this.fcs.errorHandeler(res);
      }
    }, (err) => this.fcs.errorHandeler(err))
    );
  }

  /**
   * Load page content.
   */
  loadPageContent(): void {
    this.getPostedByFilterData();
    this.getPostsData();
    this.getMembersFilterData();
  }
  /**
   * Inactivate community modal.
   */
  inactivateCommunity(): void {
    this.analyticSdk.analyticService.CLICK(PRODUCT_TYPE_CONSTANT_NAME.COMMUNITY, this.communityDetail?.da_id ?? 0, this.fcs.currentScreename, CTA_TYPE.MORE_OPTION, ACTION_TYPE.CLICK, ACTION_ON.INACTIVATE_COMMUNITY, null);
    this.showInactivateModal = true;
  }
  /**
   * Inactivate community confirm modal.
   */
  inactivateCommunityYes(): void {
    this.showInactivateModal = false;
    this.showInactivateConfirmModal = true;
  }
  /**
   * Inactivate community.
   */
  inactivateCommunityConfirm(): void {
    this.analyticSdk.analyticService.CLICK(PRODUCT_TYPE_CONSTANT_NAME.COMMUNITY, this.communityDetail?.da_id ?? 0, SCREEN_NAME.COMMUNITY_DETAIL, CTA_TYPE.BUTTON, ACTION_TYPE.CLICK, ACTION_ON.DEACTIVATE_COMMUNITY_CONFIRM, null);
    this.activateDeactivate(COMMUNITY_STATUS.INACTIVE);
  }
  /**
   * Activate community.
   */
  ativateCommunity(): void {
    this.analyticSdk.analyticService.CLICK(PRODUCT_TYPE_CONSTANT_NAME.COMMUNITY, this.communityDetail?.da_id ?? 0, SCREEN_NAME.COMMUNITY_DETAIL, CTA_TYPE.TEXT, ACTION_TYPE.CLICK, ACTION_ON.ACTIVATE_COMMUNITY, null);
    this.activateDeactivate(COMMUNITY_STATUS.ACTIVE);
  }
  /**
   * Activate/deactive community
   */
  activateDeactivate(state): void {
    this.subscriptions.add(this.postService.activateInactivateCommunity(this.communityId, state)
      .subscribe((res: GenericResponse) => {
        if (res.status === NUMBERS.ONE) {
          this.showInactivateConfirmModal = false;
          this.tabSuccess = COMMUNITY_DETAIL_ACTION_TAB.POSTS;
          this.getCommunityDetail();
        } else {
          this.fcs.errorHandeler(res);
        }
      }, err => this.fcs.errorHandeler(err)));
  }
  /**
   * Access level community.
   */
  checkAccessLevel(): boolean {
    if (this.activateAccess.indexOf(COMMUNITY_USER_TYPE.ADMIN) > -1 || this.activateAccess.indexOf(COMMUNITY_USER_TYPE.CREATOR) > -1) {
      return true;
    } else {
      return false;
    }
  }
  /**
   * Show nudge more options.
   */
  showDeactivateOption(): void {
    this.showDeactivateOptionNudge = true;
  }
  /**
   * Allow withdraw request.
   */
  allowAction(isAllow: boolean): void {
    if (isAllow) {
      this.resetConfirmModal();
      const start_time = new Date().getTime().toString();
      this.analyticSdk.analyticService.CLICK(PRODUCT_TYPE_CONSTANT_NAME.COMMUNITY, this.communityDetail?.da_id ?? 0, SCREEN_NAME.COMMUNITY_DETAILS, CTA_TYPE.BUTTON, ACTION_TYPE.CLICK, ACTION_ON.WITHDRAW_REQUEST, null);
    }
  }
  /**
   * Reset confirm modal.
   */
  resetConfirmModal(): void {
    this.confirmationModal = false;
  }

  /**
   * Event handler to reload feed
   * @param isReloadFeed boolean
   */
  reloadFeed(isReloadFeed: boolean): void {
    if (isReloadFeed) {
      this.isReloadFeed = isReloadFeed;
      this.getPostsData();
    }
  }

  /**
   * product Share
   */
  productShare(): void {
    this.analyticSdk.analyticService.CLICK(PRODUCT_TYPE_CONSTANT_NAME.COMMUNITY, this.communityDetail?.da_id ?? 0, SCREEN_NAME.COMMUNITY_DETAIL, CTA_TYPE.BUTTON, ACTION_TYPE.CLICK, ACTION_ON.SHARE, null
    );
    const shareProduct = [{
      share_url: '',
      share_contentt: null,
      product_type: PRODUCT_TYPE_CONSTANT.COMMUNITY,
      product_type_id: this.communityDetail.da_id
    }];
    this.fcs.productShare(shareProduct);
  }
  /**
   * open Members popup.
   */
  openMembersPopup(): void {
    if (this.selectedMembers.findIndex(index => index.custom_id === this.createCommunityService.loggedInUser.custom_id) === NUMBERS.MINUS_ONE) {
      this.selectedMembers.push(this.createCommunityService.loggedInUser);
    }
    this.membersIsViewAllEnable = false;
    this.createCommunityService.membersSuggestionList = [];
    this.membersSearchType = MEMBERS_LIST_TYPE.CONNECTION;
    this.membersIsSuggestion = NUMBERS.ONE;
    this.membersKeyword = '';
    this.createCommunityService.membersSuggestionOffset = NUMBERS.ONE;
    this.callConnectionList(this.isMemberConcat);
    this.isMembersSelectionOpen = true;
    if (!this.communityId && !this.memberCount) {
      this.memberCount = this.selectedMembers.length || NUMBERS.ONE;
    }

    if (this.communityId) {
      this.getMemberCount();
    }
  }

  /**
   * Close member popup.
   */
  closeMembersPopup(): void {
    this.isMembersSelectionOpen = false;
    this.selectedMembers = [...this.preSelectedMembersList];
    if (this.communityId || !this.memberCount) {
      this.membersSelectedRemoved = [];
    }
  }

  /**
   * Calling connection list
   */
  callConnectionList(isMemberConcat: boolean): void {
    this.createCommunityService.connectionList(this.membersSearchType, this.createCommunityService.membersSuggestionOffset, this.membersIsSuggestion, this.membersKeyword, {}, isMemberConcat, this.communityId);
  }
  /**
   * Searching in connection list
   */
  searchInConnectionList(keyword: string): void {
    this.createCommunityService.membersSuggestionOffset = NUMBERS.ONE;
    this.membersKeyword = keyword;
    this.callConnectionList(this.isMemberConcat);
    this.subscriptions.add(this.getApiService.getCommunityMembers('', this.communityId, this.offset, '').subscribe((res: CommunityMembersResponse) => {
      if (res.status === NUMBERS.ONE) {
        this.offset = res.data.offset;
        this.selectedMembers = this.selectedMembers.concat(res.data.members);
      }
    }));
  }
  /**
   * Method for view all in member list
   */
  viewAllMembers(key: string): void {
    this.createCommunityService.membersSuggestionOffset = NUMBERS.ONE;
    this.membersIsSuggestion = (key === MEMBERS_LIST_TYPE.CONNECTION) ? IS_SUGGESTION.NO : IS_SUGGESTION.YES;
    this.membersSearchType = (key === MEMBERS_LIST_TYPE.CONNECTION) ? MEMBERS_LIST_TYPE.CONNECTION : MEMBERS_LIST_TYPE.SUGGESTION;
    this.callConnectionList(this.isMemberConcat);
    this.membersIsViewAllEnable = true;
  }
  /**
   * going back to member suggestion
   */
  backToMembersSuggestion(): void {
    this.membersIsSuggestion = NUMBERS.ONE;
    this.createCommunityService.membersSuggestionOffset = NUMBERS.ONE;
    this.membersSearchType = MEMBERS_LIST_TYPE.CONNECTION;
    this.membersIsViewAllEnable = false;
    this.callConnectionList(this.isMemberConcat);
  }
  /**
   * Method for updating member count
   */
  checkUncheckMember(event: boolean): void {
    if (!this.memberCount) {
      this.memberCount = NUMBERS.ZERO;
    }
    if (event) {
      this.memberCount = this.memberCount + NUMBERS.ONE;
    } else {
      this.memberCount = this.memberCount - NUMBERS.ONE;
    }
  }

  /**
   * Selected members.
   */
  membersSelected(data): void {
    const index = this.membersSelectedRemoved.findIndex((item) => {
      return item.custom_id === data.custom_id;
    });
    if (index !== -NUMBERS.ONE) {
      this.membersSelectedRemoved.splice(index, NUMBERS.ONE);
    }
    this.membersSelectedRemoved.push(data);
  }
  /**
   * Remove selcted members.
   */
  membersRemoved(data): void {
    const index = this.membersSelectedRemoved.findIndex((item) => {
      return item.custom_id === data.custom_id;
    });
    if (index != -NUMBERS.ONE) {
      this.membersSelectedRemoved.splice(index, NUMBERS.ONE);
    }
    if (data.is_community_member) {
      this.membersSelectedRemoved.push(data);
    }

  }


  /**
   * On scroll of community member.
   */
  onCommunityMemberScroll(): void {
    if (this.offset && this.offset !== NUMBERS.TWO) {
      this.subscriptions.add(this.getApiService.getCommunityMembers('', this.communityId, this.offset, '').subscribe((res: CommunityMembersResponse) => {
        if (res.status === NUMBERS.ONE) {
          this.offset = res.data.offset;
          this.selectedMembers = this.selectedMembers.concat(res.data.members);
        }
      }));
    }
  }
  /**
   * For member count
   */
  getMemberCount(): void {
    this.getApiService.getCommunityDetail(this.communityId).subscribe((res: CommunityDetailResponse) => {
      if (res.status === NUMBERS.ONE) {
        this.memberCount = res.data.detail.members.count;
      }
    });
  }
  /**
   * On Member scroll
   */
  onMembersScroll(): void {
    if (this.createCommunityService.membersSuggestionOffset > NUMBERS.ONE && this.membersIsViewAllEnable) {
      this.callConnectionList(!this.isMemberConcat);
    }
  }
  /**
   * Event for updating member count
   */
  addMember(event): void {
    this.memberToBeAdded = event;
    this.communityDetail.members.count = this.memberCount + this.memberToBeAdded.length;
    this.selectedTab(this.communityDetailActionTab.POSTS);
  }
  /**
   * For resetting member count on detail
   */
  resetCount(): void {
    this.communityDetail.members.count = this.memberCount;
  }

  /**
   * Redirect to community home
   */
  redirectToDetail(): void {
    this.fcs.navigateToCommunityModule();
  }

  /**
   * get the post enable/disable flag.
   */
    postDisableCheck(): void {
      const checkDisableSub = this.postService.getPostButtonStatus()
        .subscribe((res: boolean) =>  this.isPostButtonDisable = res);
      this.subscriptions.add(checkDisableSub);
    }

  /**
   * Get topic list
   */
  getTopicList(): void {
    this.subscriptions.add(this.getApiService.getTopicList(this.communityId).subscribe(data => {  
      const all =  {code: "", name: "All"}
      this.topicList = data?.data?.list
      this.topicList.unshift(all);
    }));
  }

  /**
   * Get post when user click on post
   */
  getPost(): void {
    const filterObj = {posted_by: '', content_type: '', topic: '', scroll: false};
    this.getPostsByFilter(filterObj);
  }
  
}
